export const GameStates = {
    LOADING: "LOADING",
    MENU: "MENU",
    GAME: "GAME",
    QUIZ: "QUIZ",
    SHOW_ANSWER: "SHOW_ANSWER",
    GAME_OVER: "GAME_OVER",
    WON: "WON",
  } as const;
  